import { SvgIconProps } from "@mui/material";
import Icons from "icons/sidebar";
import type { ComponentType } from "react";
import { APP_SCHEDULE_PLAN } from "utils/constants";

export interface MenuItem {
  title: string;
  path: string;
  Icon: ComponentType<SvgIconProps>;
}

const index: MenuItem[] = [
  {
    title: "Dashboard",
    Icon: Icons.DashboardIcon,
    path: "/main",
  },
  /*{
    title: "User Profile",
    Icon: Icons.UserProfileIcon,
    path: "/main/administration",
  },*/
  {
    title: "Contatos",
    Icon: Icons.UserProfileIcon,
    path: "/main/contact",
  },
  {
    title: "Agenda",
    Icon: Icons.ScheduleIcon,
    path: "/main/schedule",
  },
  {
    title: "Planos recorrentes",
    Icon: Icons.SessionsIcon,
    path: APP_SCHEDULE_PLAN.BASE_PATH,
  },
];

export default index;
